import React from 'react';

import { withEventScope } from '@repo/event-processor';
import type { Subscription } from '@repo/subscription/api';
import {
  subscriptionStoreSelector,
  useSubscriptionStore,
} from '@repo/subscription/client';
import EditIcon from '@repo/ui/components/Icon/EditIcon';
import { Spacer } from '@repo/ui/components/Spacer';
import { P3 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import { TableRow, CardInfo } from './styles';

/**
 * This component displays the user's credit card information and provides an option to edit the card details.
 */
const CardSection: React.FC<{
  card: NonNullable<Subscription['card']>;
}> = ({ card }) => {
  const openBillingPortal = useSubscriptionStore(
    subscriptionStoreSelector.openBillingPortal
  );

  return (
    <>
      <Spacer height="4px" />
      <TableRow>
        <P3 color={themeStyle.varInkMedium}>Credit Card</P3>
        <CardInfo onClick={openBillingPortal}>
          <P3 color={themeStyle.varInkMedium} style={{ textAlign: 'right' }}>
            {card.brand} ···· {card.last4}
          </P3>
          <Spacer width="4px" />
          <EditIcon height="10px" theme={{ color: themeStyle.varInkMedium }} />
        </CardInfo>
      </TableRow>
    </>
  );
};

export default withEventScope(CardSection, { module: 'cardSection' });
